/*------------------------------------*\
    process steps
\*------------------------------------*/
module.exports = function(){


    // customization utils
    var custUtils = require('../integration/cust-utils.js');



    // helpers

    var custDialog = {


        open: function(){

            $('.js-product-description').removeClass('is-current');
            $('.js-product-customize').addClass('is-current');
            $('.js-step').eq(0).addClass('is-current');
            $('.js-step-trigger').eq(0).addClass('is-current');

        },



        addFinishedClasses: function(){


            $('.js-step').removeClass('is-finished');
            $('.js-step-trigger').removeClass('is-finished');

            var prevStep = $('.js-step.is-current').prevAll('.js-step');
            if (prevStep.length) {
                prevStep.addClass('is-finished');
            }


            var prevStepTrigger = $('.js-step-trigger.is-current').prevAll('.js-step-trigger');
            if (prevStepTrigger.length) {
                prevStepTrigger.addClass('is-finished');
            }

        },


        openStep: function(index){


            //hax0r fix
            setTimeout(function(){

                var $stepTrigger = $('.js-step-trigger[data-step="'+ index + '"]');
                var $stepIndex = $('.js-step[data-step="' + index + '"]');

                $stepIndex.addClass('is-current');
                $stepTrigger.addClass('is-current');

                $('.js-step-trigger').not($stepTrigger).removeClass('is-current');
                $('.js-step').not($stepIndex).removeClass('is-current');
                $('.js-radio-step-trigger').removeClass('is-clicked');

                this.addFinishedClasses();

            }.bind(this), 1);

        },


        nextStep: function(){


            // Close all tooltips when you go to the next page.
            window.styleAdviceTooltips.close({ignoreDelay: true});


            //hax0r fix
            setTimeout(function(){




                var nextStep = $('.js-step.is-current').next('.js-step');
                $('.js-step').removeClass('is-current');
                nextStep.addClass('is-current');



                var nextStepTrigger = $('.js-step-trigger.is-current').next('.js-step-trigger');
                $('.js-step-trigger').removeClass('is-current');
                nextStepTrigger.addClass('is-current');


                this.addFinishedClasses();



                if ($(window).width() < 900 ) {

                    $('html, body').animate({
                        scrollTop: $('.js-product-customize-form').offset().top - 100
                    }, 500);

                }



            }.bind(this), 1);


        },




        close: function(){




            //hax0r fix
            setTimeout(function(){

                $('.js-step').removeClass('is-current');
                $('.js-step-trigger').removeClass('is-current');

                $('.js-step').removeClass('is-finished');
                $('.js-step-trigger').removeClass('is-finished');

                $('.js-step').eq(0).addClass('is-current');
                $('.js-step-trigger').eq(0).addClass('is-current');

                $('.js-product-customize').removeClass('is-current');
                $('.js-product-description').addClass('is-current');

            }.bind(this), 1);




        },




    };













    // step trigger click (bullets on bottom)

    $('.js-step-trigger').on('click', function(event) {
        event.preventDefault();

        if ( !custUtils.validateRequiredStep(this) ) {
            return false;
        }

        // does the job that validateRequiredStep missed
        if ( !custUtils.validateStepTriggerClick(this, event) ) {
            return false;
        }

        if ( !custUtils.validateMonogram(this) ) {
            return false;
        }


        custDialog.openStep($(this).data('step'));

    });







    // customization option click
    $(document).on('click', '.js-next-step-input', function(event) {
        event.preventDefault();

        $(this).find('input').prop('checked', true);

        setTimeout(function(){
            custDialog.nextStep();
        }.bind(this), 100);

    });

    $(document).on('click', '.js-liner-next-step-button', function(event) {
        event.preventDefault();

        if ( !$(event.target).closest(".step").find("input[type=radio]:checked").length ) {
            alertify.alert('Before moving forward you need to choose a liner fabric.');
            return false;
        }

        custDialog.nextStep();

    });




    // next step button

    $('.js-next-step-btn').on('click', function(event) {
        event.preventDefault();

        if ( !custUtils.validateMonogram(this) ) {
            return false;
        }

        custDialog.nextStep();

    });



    // close steps button

    $('.js-close-steps-btn').on('click', function(event) {
        event.preventDefault();

        if ( !custUtils.validateMonogram(this) ) {
            return false;
        }

        custDialog.close();

    });















    // Lighten the active state label when a label is displayed on hover

    $('.js-step-trigger').on('mouseenter', function(event) {
        $('.js-step-trigger.is-current').find($('.steps__label')).css({'opacity': 0});
    });

    $('.js-step-trigger').on('mouseleave', function(event) {
        $('.js-step-trigger.is-current').find($('.steps__label')).css({'opacity': ''});
    });

    $('.js-step-trigger').on('click', function(event) {
        $('.js-step-trigger').not($(this)).find($('.steps__label')).css({'opacity': ''});
    });



    // Main Customize Button in product page

    $(document).on('click', '.js-product-customize-trigger', function(event) {
        event.preventDefault();
        //console.warn('.js-product-customize-trigger click - steps.js');

        //console.log('clicked customize button')

        if (!!$(this).data('is-multiple')) {
            //console.log('item to be customized is multiple, invoking alert')
            return;
        }

        if (!!$(this).attr('startover')) {
            //console.log('starting over customizations as requested')
            lsCart.remove( $(this).attr('data-webprod-id') );
        }


        //hax0r fix
        setTimeout(function(){

            //console.log('hax0r fix')

            if ($('.js-product-container').length) {
                //console.log('matched', "$('.js-product-container').length")

                $('.js-product-container').find('.js-step').eq(0).addClass('is-current');
                $('.js-product-container').find('.js-step-trigger').eq(0).addClass('is-current');

            }

            if ($('.js-profile-order-customize-wrapper').length) {
                //console.log('matched', "$('.js-profile-order-customize-wrapper').length")

                $(this).closest('.js-profile-order-customize-wrapper').find('.js-step').eq(0).addClass('is-current');
                $(this).closest('.js-profile-order-customize-wrapper').find('.js-step-trigger').eq(0).addClass('is-current');

            }
            $(".steps--customize").css("position","absolute");
        }.bind(this), 30);


    });









}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/steps.js